import React from 'react'
import { observer } from 'mobx-react-lite'
import CampaignInfluencerTags from './CampaignInfluencerTags'

export default observer(function TagsPage({ auth }) {
  const authCampTags = auth.tags.reduce((result, tag) => { if (tag.campaign_id !== null) { result.push(tag) } return result }, [])
  const authTags = auth.tags.reduce((result, tag) => { if (tag.campaign_id === null) { result.push(tag) } return result }, [])

  return (
    <div className='mt-5 px-4'>
      <h2 className='text-xl font-bold'>Campaign</h2>
      <CampaignInfluencerTags auth={auth} currentTags={authCampTags} />
      <h2 className='text-xl font-bold'>Public</h2>
      <CampaignInfluencerTags auth={auth} currentTags={authTags} arePublic />
    </div>
  )
})
